var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToastErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    fill: "#F50404"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.999 14.4994C13.9333 14.4995 13.8682 14.4866 13.8075 14.4616C13.7467 14.4365 13.6915 14.3997 13.645 14.3533L10.9995 11.7043L8.35299 14.3533C8.25925 14.4471 8.13211 14.4998 7.99956 14.4998C7.867 14.4998 7.73987 14.4471 7.64612 14.3533C7.5524 14.2594 7.49976 14.1322 7.49976 13.9995C7.49976 13.8668 7.5524 13.7396 7.64612 13.6457L10.2926 10.9967L7.64612 8.34775C7.55506 8.25338 7.50467 8.12698 7.50581 7.99578C7.50695 7.86459 7.55952 7.73909 7.65221 7.64631C7.7449 7.55354 7.87028 7.50091 8.00136 7.49977C8.13243 7.49863 8.25871 7.54907 8.35299 7.64022L10.9995 10.2892L13.645 7.64022C13.7393 7.54907 13.8656 7.49863 13.9967 7.49977C14.1277 7.50091 14.2531 7.55354 14.3458 7.64631C14.4385 7.73909 14.4911 7.86459 14.4922 7.99578C14.4933 8.12698 14.443 8.25338 14.3519 8.34775L11.7064 10.9967L14.3529 13.6447C14.423 13.7147 14.4707 13.8039 14.4901 13.9011C14.5095 13.9983 14.4996 14.0991 14.4617 14.1906C14.4237 14.2821 14.3595 14.3604 14.2772 14.4153C14.1948 14.4703 14.098 14.4995 13.999 14.4994Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastErrorIcon);
export default __webpack_public_path__ + "static/media/ToastErrorIcon.437af2af310609d0f64c3faebd68310d.svg";
export { ForwardRef as ReactComponent };